import React, { useState } from 'react';
import { FaEnvelope, FaLock } from 'react-icons/fa';
import io from 'socket.io-client';

const socket = io('http://localhost:4800');  // Connexion au serveur Node.js

function Membres() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');

    // Gérer la soumission du formulaire
    const handleSubmit = (e) => {
        e.preventDefault();  // Empêche la soumission par défaut du formulaire

        // Afficher les valeurs dans la console
        console.log("Email:", email);
        console.log("Mot de passe:", password);

        // Émettre un événement 'register' avec l'email et le mot de passe
        socket.emit('register', { email, password });

        // Écouter les réponses du serveur
        socket.on('success', (msg) => {
            setMessage(msg);
        });

        socket.on('error', (errorMsg) => {
            setMessage(errorMsg);
        });
    };

    return (
        <div>
            <h1>Espace Membres</h1>
            <form onSubmit={handleSubmit}>
                {/* Champ pour l'email */}
                <div className="form-group">
                    <label htmlFor="email">
                        <FaEnvelope style={{ marginRight: '8px' }} /> Email :
                    </label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Entrez votre adresse email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="input-field"
                    />
                </div>

                {/* Champ pour le mot de passe */}
                <div className="form-group">
                    <label htmlFor="password">
                        <FaLock style={{ marginRight: '8px' }} /> Mot de passe :
                    </label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        placeholder="Entrez votre mot de passe"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="input-field"
                    />
                </div>

                {/* Bouton de soumission */}
                <button type="submit" className="submit-btn">Valider</button>
            </form>

            {/* Afficher le message */}
            {message && <p>{message}</p>}
        </div>
    );
}

export default Membres;
